const initialState = {
	td: null,
}

export default function tdSelectorReducer(state = initialState, action) {
	switch (action.type) {
		case "FOCUS_TD": {
			return {
				...state,
				td: action.td
			}
		}
		case "BLUR_TD": {
			return {
				...state,
				td: null
			}
		}
		default:
			return state
	}
}